import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Job } from '../../models/hangfireJobs/job.model';
import { JobLog } from '../../models/hangfireJobs/JobLog.model';
import { RecurringJob } from '../../models/hangfireJobs/recurringJob.model';
import { PageList } from '../../models/pageList.model';
import { HttpClientBaseService } from '../base/httpClientBase.service';
import { IServiceBase } from '../base/IServiceBase';

@Injectable()
export class RecurringJobService extends HttpClientBaseService implements IServiceBase<RecurringJob> {

  constructor(_http: HttpClient) {
    super(_http,'Hangfire/RecurringJobs/','',false);
  }

  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<RecurringJob>> {
    throw new Error('Method not implemented.');
  }
  getAllModels(): Observable<RecurringJob[]> {
    return super.getAll<RecurringJob[]>();
  }
  getModel(id: any): Observable<RecurringJob> {
    return super.getSingle<RecurringJob>(id);
  }

  getLog(recurringJobId: any): Observable<JobLog> {
    const url = `${this.getUrl(recurringJobId, null)}/log`;
    return super.get<JobLog>(url);
  }

  getJobs(recurringJobId: any): Observable<Job[]> {
    const url = `${this.getUrl(recurringJobId, null)}/jobs`;
    return super.get<Job[]>(url);
  }

  updateCronInterval(id:any, cronExpression: string){
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this.http.put<string>(this.getUrl(id, null), JSON.stringify(cronExpression), {headers: headers});
  }


}
